import { Endereco } from './../../../../models/endereco';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';
import { AbEnderecoContato } from 'app/abstract/full-pages/meus-dados/endereco-contato.abstract';


@Injectable({ providedIn: 'root' })
export class EnderecoContatoService extends AbEnderecoContato {

  constructor(http: HttpClient) {
    super(http);
  }

  public getEnderecoCompleto(cep: number): Observable<any> {
    return this.get(`enderecos/cep/${cep}`);
  }

  public getEnderecoTipoEndereco(tipoEndereco: String): Observable<any> {
    return this.get(`enderecos/tipoendereco/${tipoEndereco}`);
  }

  public getEnderecoTipoEnderecoByPessoaId(tipoEndereco: String, pessoaId: number, isSigma: boolean): Observable<any> {
    return this.get(`enderecos/tipoendereco/${tipoEndereco}/${pessoaId}/${isSigma}`);
  }

  public getEnderecoConta(idConta: number): Observable<any> {
    return this.get("admin/enderecos/" + idConta);
  }

  public salvarAdmin(endereco: Endereco): Observable<any> {
    return this.save("admin/enderecos/", endereco);
  }

  public salvar(endereco: Endereco): Observable<any> {
    return this.save("enderecos/", endereco);
  }

  public getPaises(): Observable<any> {
    return this.get(`admin/pais/all`);
  }

  public obrigatoriedadeCampo(obrigatorio, campo): Boolean {
    if (obrigatorio) {
      campo.setValidators(Validators.compose([Validators.required]));
      campo.updateValueAndValidity({ onlySelf: true });
      return;
    }

    campo.setValidators(null);
    campo.updateValueAndValidity({ onlySelf: false });
  }

}
